angular.module('app').factory('HubService', function ($rootScope, Hub, $timeout) {
    var hub = new Hub('traceHub', {
        listeners: {
            'onInit': function (connId) {
                console.log(connId);
            },
            'onNewTraces': function (dto) {
                console.log(dto);
            },
            'onNewAttachments': function (dto) {
                console.log(dto);
            }
        },
        methods: ['connectedUsers'],
        queryParams: {
            'token': 'exampletoken'
        },
        rootPath: '~/signalr/signalr',
        errorHandler: function (error) {
            console.log(error);
        },
        stateChanged: function (state) {
            switch (state.newState) {
                case $.signalR.connectionState.connecting:
                    console.log('HubService connecting');
                    break;
                case $.signalR.connectionState.connected:
                    console.log('HubService connected');
                    break;
                case $.signalR.connectionState.reconnecting:
                    console.log('HubService reconnecting');
                    break;
                case $.signalR.connectionState.disconnected:
                    console.log('HubService disconnected');
                    break;
            }
            console.log(state);
        }
    });
    var connectedUsers = function () {
        // return hub.connectedUsers();
    };
    return {
        connectedUsers: connectedUsers
    };
});
//# sourceMappingURL=Hub.service.js.map